import type { ItineraryData, TabTypes } from '../../../types';
import { Utils } from '../../../utils';
import { HEADER_TABS_LABELS } from '../constants';

export const generateTabLabels = (selectedData: ItineraryData, type: 'dates' | 'time') => {
  if (type === 'dates') {
    return Object.entries(selectedData).reduce(
      (acc, [key, date]) => {
        if (date) {
          const formattedDate = Utils.format.formatDate(date as string, 'ddd, DD MMM');
          return { ...acc, [key]: Utils.format.capitalizeFirstLetter(formattedDate) };
        }

        return { ...acc, [key]: HEADER_TABS_LABELS[key as TabTypes] };
      },
      { pickup: '', dropoff: '' },
    );
  } else {
    return Object.entries(selectedData).reduce(
      (acc, [key, timeValue]) => {
        if (timeValue) {
          return { ...acc, [key]: timeValue };
        }

        return { ...acc, [key]: HEADER_TABS_LABELS[key as TabTypes] };
      },
      { pickup: '', dropoff: '' },
    );
  }
};
